import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, InputNumber, message, Popconfirm } from "antd";
import { store } from '../../../app/store';
import { ServicesConfig } from "../../../service/servicesConfig";

const MapLayerSrvSecManager = () => {
  const [associations, setAssociations] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingAssociation, setEditingAssociation] = useState(null);
  const [form] = Form.useForm();

  const baseURL = ServicesConfig.getBaseUrlV2()  + "/admin/map_layer_srv_sec"; // Base URL para SGVMAP_MAP_LAYER_SRV_SECController

  
  const getAuthorization = () => {
    const state = store.getState();
    return state.user.logged ? "Bearer " + state.user.token : ""
  }
  
  // Obtener todas las asociaciones
  const fetchAssociations = async () => {
    try {
      const response = await fetch(`${baseURL}/list`, {
        headers: { Authorization: getAuthorization() },
      }); // Endpoint para listar todas las asociaciones
      if (!response.ok) throw new Error("Error al obtener las asociaciones");
      const data = await response.json();
      setAssociations(data);
    } catch (error) {
      message.error("Error al obtener la lista de asociaciones");
      console.error(error);
    }
  };

  // Crear o actualizar una asociación
  const handleSaveAssociation = async (values) => {
    const method = editingAssociation ? "PUT" : "POST";
    const url = editingAssociation
      ? `${baseURL}/update`
      : `${baseURL}/create`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
        body: JSON.stringify(values),
      });
      if (!response.ok) throw new Error("Error al guardar la asociación");

      message.success(
        editingAssociation
          ? "Asociación actualizada correctamente"
          : "Asociación creada correctamente"
      );
      fetchAssociations();
      setIsModalOpen(false);
      setEditingAssociation(null);
      form.resetFields();
    } catch (error) {
      message.error("Error al guardar la asociación");
      console.error(error);
    }
  };

  // Eliminar una asociación
  const handleDeleteAssociation = async (idMapLayer, idSrvSec) => {
    try {
      const response = await fetch(`${baseURL}/delete/${idMapLayer}/${idSrvSec}`, {
        method: "DELETE",
        headers: {
          Authorization: getAuthorization(),
        },
      });
      if (!response.ok) throw new Error("Error al eliminar la asociación");

      message.success("Asociación eliminada correctamente");
      fetchAssociations();
    } catch (error) {
      message.error("Error al eliminar la asociación");
      console.error(error);
    }
  };

  // Abrir modal para edición
  const handleEdit = (association) => {
    setEditingAssociation(association);
    form.setFieldsValue(association);
    setIsModalOpen(true);
  };

  // Abrir modal para creación
  const handleCreate = () => {
    setEditingAssociation(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchAssociations();
  }, []);

  const columns = [
    {
      title: "ID Capa de Mapa",
      dataIndex: "idMapLayer",
      key: "idMapLayer",
    },
    {
      title: "ID Servicio de Seguridad",
      dataIndex: "idSrvSec",
      key: "idSrvSec",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar esta asociación?"
            onConfirm={() => handleDeleteAssociation(record.idMapLayer, record.idSrvSec)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Asociaciones Capa de Mapa - Servicio de Seguridad</h1>
      <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
        Crear Asociación
      </Button>
      <Table
        columns={columns}
        dataSource={associations}
        rowKey={(record) => `${record.idMapLayer}-${record.idSrvSec}`}
      />

      <Modal
        title={editingAssociation ? "Editar Asociación" : "Crear Asociación"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveAssociation}
          initialValues={{ idMapLayer: "", idSrvSec: "" }}
        >
          <Form.Item
            name="idMapLayer"
            label="ID Capa de Mapa"
            rules={[{ required: true, message: "Por favor, ingrese el ID de la capa de mapa" }]}
          >
            <InputNumber min={1} placeholder="ID de la Capa de Mapa" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="idSrvSec"
            label="ID Servicio de Seguridad"
            rules={[{ required: true, message: "Por favor, ingrese el ID del servicio de seguridad" }]}
          >
            <InputNumber min={1} placeholder="ID del Servicio de Seguridad" style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MapLayerSrvSecManager;
